// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-page, .feature-container {\n    max-width: none;\n    margin: 20px;\n}\n\n.feature-title {\n    font-weight: bold;\n}\n\n.action-button {\n    cursor: pointer;\n    text-decoration: underline;\n}", ""]);
// Exports
module.exports = exports;
